<template>
  <Card>
    <div v-if="user">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold">درخواست های بازار</p>
                  <h3 class="my-2">{{ (reportData.n_marketRequest ? reportData.n_marketRequest : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold">پیشنهادهای ارسالی بازار</p>
                  <h3 class="my-2">{{ (reportData.n_market_send_offer ? reportData.n_market_send_offer : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold">پیشنهادهای دریافتی بازار</p>
                  <h3 class="my-2">
                    {{ (reportData.n_market_receive_offer ? reportData.n_market_receive_offer : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold">درخواست های مزایده</p>
                  <h3 class="my-2">{{ (reportData.n_auctionRequest ? reportData.n_auctionRequest : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold">پیشنهادهای ارسالی مزایده</p>
                  <h3 class="my-2">{{ (reportData.n_auction_send_offer ? reportData.n_auction_send_offer : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold">پیشنهادهای دریافتی مزایده</p>
                  <h3 class="my-2">
                    {{ (reportData.n_auction_receive_offer ? reportData.n_auction_receive_offer : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold">تعداد معاملات</p>
                  <h3 class="my-2">{{ (reportData.n_transaction ? reportData.n_transaction : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
        <div class="col-md-6 col-lg-4">
          <div class="card report-card">
            <div class="card-body">
              <div class="row d-flex justify-content-center">
                <div class="col">
                  <p class="text-dark mb-1 font-weight-semibold"> معاملات موفق</p>
                  <h3 class="my-2">{{ (reportData.success_transaction ? reportData.success_transaction : '0') }}</h3>
                </div>
              </div>
            </div><!--end card-body-->
          </div><!--end card-->
        </div> <!--end col-->
      </div>
      <h5 class="font-weight-bold my-2">لاگ فعالیت مشتری</h5>
      <LocalDataTable :columns="columns" :ajaxLink="ajaxLink"></LocalDataTable>
    </div>
    <div v-if="error" class="alert alert-danger">{{error}}</div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import {UserApi} from "@/api/UserApi";
import LocalDataTable from "@/components/LocalDataTable";
export default {
  name: "UserActivityLogPage",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      id : this.$route.params.id,
      user : null,
      error : null,
      reportData : {},
      columns : [{title : 'تاریخ'},{title : 'َشرح'}],
      ajaxLink : 'admin/User/UserLogList/'+this.$route.params.id,
    }
  },
  mounted()
  {
    this.setPageTitle('');
    this.setShowHead(true);
    this.setPageLoading(false);
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.id = this.$route.params.id;
      this.user = null;
      this.error =null;
      const result = await UserApi.getUserActivity(this.id);
      if (result.ok)
      {
        // data = {user,n_marketRequest,n_auctionRequest,n_market_send_offer,n_auction_send_offer,n_market_receive_offer,n_auction_receive_offer,n_transaction,success_transaction}
        this.user = result.user;
        this.reportData = result.data;
        this.setPageTitle('فعالیت '+(this.user.title?this.user.title:'')+'('+this.user.phone+')')
      }
      else
        this.error = result.error;
      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>